import { EmptyState } from "@/components/shared/Common";
import { clp } from "@/lib/format";

const SUMS = [["sueldo", "Sueldo"], ["he_monto", "$ HH.EE."], ["gratificacion", "Gratif."], ["imponible", "Imponible"], ["afp", "AFP"], ["salud", "Salud"],
  ["cesantia", "Cesantía"], ["impuesto", "Impuesto"], ["no_imponibles", "No imp."], ["otros_descuentos", "Otros desc."]];
const th = "px-2 py-2 font-semibold whitespace-nowrap";

const DayCell = ({ d }) => (
  <td className={`px-1 py-1 text-center border-l border-[#f0f2ee] ${d?.sin_salida ? "bg-[#fff6e0]" : ""}`}>
    {d?.code && <div className="font-mono text-[10px] font-bold">{d.code}</div>}
    {d?.he > 0 && <div className="text-[10px] text-[#1d4f91] font-semibold">+{d.he}</div>}
  </td>
);

export const PayrollGrid = ({ run, onOpen }) => {
  const n = run.days_in_month || 31;
  const keys = Array.from({ length: n }, (_, i) => String(i + 1).padStart(2, "0"));
  if (!run.lines.length) return <EmptyState title="Sin asistencia en el período" />;
  return (
    <div className="overflow-x-auto"><table className="text-xs border-collapse min-w-max" data-testid="payroll-grid">
      <thead className="bg-[#f7f9f5]"><tr>
        <th className={`${th} text-left sticky left-0 bg-[#f7f9f5] z-10 min-w-[200px]`}>Trabajador</th>
        {keys.map((k) => <th key={k} className="px-1 py-2 w-9 text-center font-semibold border-l border-[#e4e8e1]">{Number(k)}</th>)}
        <th className={`${th} text-right border-l border-[#e4e8e1]`}>Días</th><th className={`${th} text-right`}>HH.EE.</th>
        {SUMS.map(([k, l]) => <th key={k} className={`${th} text-right`}>{l}</th>)}<th className={`${th} text-right`}>Líquido</th>
      </tr></thead>
      <tbody>{run.lines.map((l) => (
        <tr key={l.employee_id} data-testid={`line-${l.employee_id}`} onClick={() => onOpen(l)} className="border-b border-[#f0f2ee] hover:bg-[#f6fbf2] cursor-pointer">
          <td className="px-2 py-1.5 sticky left-0 bg-white z-10">
            <div className="font-semibold text-sm">{l.name}</div>
            <div className="text-[10px] text-[#8a9584]">{l.rut}{l.pay_missing && <span className="ml-1 font-bold text-[#b42318]" data-testid={`line-pay-missing-${l.employee_id}`}>· sin sueldo en ficha</span>}</div>
          </td>
          {keys.map((k) => <DayCell key={k} d={l.days[k]} />)}
          <td className="px-2 text-right border-l border-[#e4e8e1]">{l.worked_days}</td>
          <td className="px-2 text-right text-[#1d4f91] font-semibold">{l.calc.he_hours}</td>
          {SUMS.map(([k]) => <td key={k} className="px-2 text-right whitespace-nowrap">{clp(l.calc[k])}</td>)}
          <td className="px-2 text-right font-bold whitespace-nowrap" data-testid={`line-total-${l.employee_id}`}>{clp(l.calc.liquido)}</td>
        </tr>))}
        <tr className="bg-[#f6fbf2] font-bold">
          <td className="px-2 py-2 sticky left-0 bg-[#f6fbf2] z-10">TOTAL ({run.totals.workers})</td>{keys.map((k) => <td key={k} />)}
          <td className="px-2 text-right">{run.totals.worked_days}</td><td className="px-2 text-right">{run.totals.he_hours}</td>
          {SUMS.map(([k]) => <td key={k} className="px-2 text-right whitespace-nowrap">{k in run.totals ? clp(run.totals[k]) : ""}</td>)}
          <td className="px-2 text-right whitespace-nowrap" data-testid="run-total">{clp(run.totals.liquido)}</td>
        </tr>
      </tbody></table></div>
  );
};
